var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default",null,{"formErrors":errors,"formSubmissionAttempted":_vm.formSubmissionAttempted})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }